const TEAM = [
  {
    id: 1,
    name: 'Hanna',
    role: 'Team-lead',
    link: 'https://github.com/Seala11',
    img: '/assets/images/team-lead.jpg',
    alt: 'tean-lead image',
  },
  {
    id: 2,
    name: 'Hanna',
    role: 'Developer',
    link: 'https://github.com/Seala11',
    img: '/assets/images/developer.jpg',
    alt: 'developer image',
  },
  {
    id: 3,
    name: 'Hanna',
    role: 'Designer',
    link: 'https://github.com/Seala11',
    img: '/assets/images/designer.jpg',
    alt: 'developer image',
  },
];

export default TEAM;
